import axios from 'axios';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getAllCookies } from '@/utils/cookies';

export const setupFPApiClient = () => {
  const cookies = getAllCookies();
  const authToken = cookies[authKeys.authToken] || '';

  const api = axios.create({
    baseURL: apiConfig.fpBaseURL,
    headers: {
      Authorization: authToken ? `Bearer ${authToken}` : undefined,
    },
  });

  return api;
};
